const tryOrUndefined = <T>(action: () => T): T | undefined => {
  try {
    return action();
  } catch (e) {
    return undefined;
  }
};

export default tryOrUndefined;
